function initMetalValuation(section) {
  if (!section) return;

  const API_KEY = section.dataset.apiKey;

  if (!API_KEY) {
    console.warn('Metal Valuation: Missing API Key');
    return;
  }

  const currency = section.dataset.currency || 'GBP';
  const buySpread = parseFloat(section.dataset.buySpread) || 0;

  // Troy ounce for gold
  const ounceToGram = parseFloat(section.dataset.ounceToGram) || 31.1034768;

  const caratEl = section.querySelector('.metalCarat');
  const qtyEl = section.querySelector('.metalQty');
  const valueText = section.querySelector('.summaryValue');
  const qtyText = section.querySelector('.summaryQuantityValue');
  const totalText = section.querySelector('.summaryTotal');

  if (!caratEl || !qtyEl || !valueText || !qtyText || !totalText) {
    console.warn('Metal Valuation: Required elements not found');
    return;
  }

  const METALS = {
    gold_9: { symbol: 'XAU', purity: 0.375, label: '9k Gold' },
    gold_14: { symbol: 'XAU', purity: 0.585, label: '14k Gold' },
    gold_18: { symbol: 'XAU', purity: 0.75, label: '18k Gold' },
    gold_21: { symbol: 'XAU', purity: 0.825, label: '21k Gold' },
    gold_22: { symbol: 'XAU', purity: 0.916, label: '22k Gold' },
    gold_24: { symbol: 'XAU', purity: 1, label: '24k Gold' },
    silver_925: { symbol: 'XAG', purity: 0.925, label: 'Silver 925' },
    silver_999: { symbol: 'XAG', purity: 0.999, label: 'Silver 999' },
    platinum_950: { symbol: 'XPT', purity: 0.95, label: 'Platinum 950' },
    platinum_999: { symbol: 'XPT', purity: 0.999, label: 'Platinum 999' },
  };

  const pricePerGram = { XAU: 0, XAG: 0, XPT: 0 };

  function formatCurrency(value) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency,
    }).format(value);
  }

  function reset() {
    valueText.textContent = '';
    qtyText.textContent = '';
    totalText.textContent = formatCurrency(0);
  }

  function animateValue(el, endValue, duration = 500) {
    const startValue = parseFloat(el.textContent.replace(/[^\d.-]/g, '')) || 0;

    const startTime = performance.now();

    function animate(currentTime) {
      const progress = Math.min((currentTime - startTime) / duration, 1);

      const currentValue = startValue + (endValue - startValue) * progress;

      el.textContent = formatCurrency(currentValue);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    }

    requestAnimationFrame(animate);
  }

  function update() {
    const carat = caratEl.value;
    let qty = parseFloat(qtyEl.value);

    if (!carat || isNaN(qty) || qty <= 0) {
      reset();
      return;
    }

    if (qty > 100) {
      qty = 100;
      qtyEl.value = 100;
      alert('Maximum allowed quantity is 100 grams.');
    }

    const metal = METALS[carat];

    if (!metal || !pricePerGram[metal.symbol]) {
      reset();
      return;
    }

    const pureValue = pricePerGram[metal.symbol] * metal.purity * qty;
    const finalValue = pureValue * (1 - buySpread / 100);

    valueText.textContent = metal.label;
    qtyText.textContent = `${qty}g`;

    animateValue(totalText, finalValue);
  }

  async function fetchPrice() {
    try {
      const response = await fetch(
        `https://metals-api.com/api/latest?access_key=${API_KEY}&base=${currency}&symbols=XAU,XAG,XPT`,
      );

      const data = await response.json();

      if (!data.success || !data.rates) {
        console.error('Invalid Metals API response', data);
        return;
      }

      for (const symbol of ['XAU', 'XAG', 'XPT']) {
        if (data.rates[symbol]) {
          pricePerGram[symbol] = data.rates[symbol] / ounceToGram;
        }
      }

      update();
    } catch (error) {
      console.error('Metals API Error:', error);
    }
  }

  fetchPrice();

  const refreshInterval = setInterval(fetchPrice, 30 * 60 * 1000);

  caratEl.addEventListener('change', update);
  qtyEl.addEventListener('input', update);

  section.addEventListener(
    'shopify:section:unload',
    () => {
      clearInterval(refreshInterval);
    },
    { once: true },
  );
}

// Page Load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.metal-valuation').forEach(initMetalValuation);
});

// Shopify Theme Editor
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;

  if (section.classList.contains('metal-valuation')) {
    initMetalValuation(section);
  }
});
